import { PageTitle } from "@/components/pageTitle";

export const Scenarios = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#F9FAFF] to-[#FFFFFF]">
      <div className=" pt-[70px] px-[240px] pb-[100px] w-[1920px]">
        <PageTitle title="应用场景" />
        <div className="mt-[70px] flex justify-between">
          <Item
            title="企业跨国办公"
            content="企业办公、SaaS应用加速、企业海外推广、品牌宣传，异地传输，不同办公点的跨国际互通互访。并且支持轻松满足千人团队同时在线使用。"
            img1="/imgs/saas/1.png"
            img2="/imgs/saas/5.png"
          />
          <Item
            title="跨境电商"
            content="TikTok平台开展直播带货，低成本，高安全稳定性，更流畅、真实的展现商品的功能优势特点。"
            img1="/imgs/saas/2.png"
            img2="/imgs/saas/6.png"
          />
          <Item
            title="AIGC海外应用"
            content="在TikTok平台上运营账号，通过创意视频直观展示产品的外观、细节、使用方法，使用户更容易理解产品的特点和优势，实现视频的种草与带货。"
            img1="/imgs/saas/3.png"
            img2="/imgs/saas/7.png"
          />
          <Item
            title="游戏出海加速"
            content="光年 CPE 路由加速盒子支持多条网线/多设备连接WIFI同时使用，每条线路均可配置不同国家/地区IP，完美支持多账号同时开播。"
            img1="/imgs/saas/4.png"
            img2="/imgs/saas/8.png"
          />
        </div>
        <div className="mt-[190px]" />
        <PageTitle title="服务流程" />
        <img src="/imgs/saas/process.png" className="mt-[80px] mx-auto" />
        <div className="flex justify-center">
          <div className="w-[196px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] flex items-center justify-center ">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#FFFFFF] text-center ">
              立即咨询使用
            </div>
          </div>
        </div>
        <div className="mt-[110px]" />
        <PageTitle title="客户案例" />
        <img src="/imgs/saas/case.png" className="mt-[80px] mx-auto" />
      </div>
    </div>
  );
};

export const Item = (props: {
  title: string;
  content: string;
  img1: string;
  img2: string;
}) => {
  return (
    <div className="w-[337px] h-[550px] bg-gradient-to-br from-[#ECF8FF] via-[#C0F3FB] to-[#77CEFF] rounded-[10px] p-[40px] flex flex-col items-center">
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[23px] text-center">
        {props.title}
      </div>
      <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-light text-[12px] color-[#253D5D]">
        {props.content}
      </div>
      <div className="flex-1" />
      <img src={props.img1} />
      <img src={props.img2} className="mt-[40px]" />
    </div>
  );
};
